import React, { useEffect, useState } from "react";
import {
    Card,
    Form,
    Input,
    Button,
    Select,
    Row,
    Col,
    message,
    Typography,
    Space,
    Switch
} from "antd";
import { ArrowLeftOutlined, SaveOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../../configs";

const { Title } = Typography;
const { Option } = Select;

export default function UserForm() {
    const [form] = Form.useForm();
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [userLevels, setUserLevels] = useState([]);

    useEffect(() => {
        const fetchUserLevels = async () => {
            try {
                const res = await axiosInstance.get("/roles");
                setUserLevels(res.data.map(role => ({
                    value: role.id_user_level,
                    label: role.user_level
                })));
            } catch (err) {
                console.error("Failed to fetch user levels:", err);
                message.error("Gagal memuat daftar role");
            }
        };
        fetchUserLevels();
    }, []);

    useEffect(() => {
        if (id) {
            setLoading(true);
            axiosInstance
                .get(`/user/${id}`)
                .then((res) => {
                    form.setFieldsValue({
                        ...res.data,
                        status: res.data.status === 1
                    });
                })
                .catch((err) => {
                    message.error("Gagal mengambil data user");
                })
                .finally(() => setLoading(false));
        }
    }, [id, form]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const payload = {
                ...values,
                status: values.status ? 1 : 0
            };

            if (!payload.password) {
                delete payload.password;
            }

            if (id) {
                await axiosInstance.put(`/user/${id}`, payload);
                message.success("User berhasil diperbarui");
            } else {
                await axiosInstance.post("/user", payload);
                message.success("User berhasil dibuat");
            }
            history.push("/referensi/users");
        } catch (err) {
            console.error(err);
            message.error(err.response?.data?.error || "Gagal menyimpan data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card bodyStyle={{ padding: "16px" }}>
            <div style={{ marginBottom: 16, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => history.push("/referensi/users")}
                />
                <Title level={4} style={{ margin: 0 }}>
                    {id ? "Edit User" : "Tambah User Baru"}
                </Title>
            </div>

            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={{ id_user_level: 2, status: true }}
            >
                <Row gutter={[16, 0]}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[{ required: true, message: "Username wajib diisi" }]}
                        >
                            <Input placeholder="Username untuk login..." />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            label={id ? "Password (kosongkan jika tidak diubah)" : "Password"}
                            name="password"
                            rules={id ? [] : [{ required: true, message: "Password wajib diisi" }]}
                        >
                            <Input.Password placeholder="Password..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 0]}>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Nama Lengkap" name="name">
                            <Input placeholder="Nama lengkap user..." />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Level User" name="id_user_level">
                            <Select>
                                {userLevels.map(level => (
                                    <Option key={level.value} value={level.value}>
                                        {level.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 0]}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            label="Status Aktif"
                            name="status"
                            valuePropName="checked"
                        >
                            <Switch checkedChildren="Aktif" unCheckedChildren="Non" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row justify="end" style={{ marginTop: 16 }}>
                    <Space wrap>
                        <Button onClick={() => history.push("/referensi/users")}>
                            Batal
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            icon={<SaveOutlined />}
                            loading={loading}
                        >
                            Simpan
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Card>
    );
}
